/* Whisply Rx wizard (shared by quick-buy + PDP). Port of live whisply-quickbuy.js Rx logic.
   Markup: snippets/wn-rx-wizard.liquid.
   API:
     var rx = WNRx.mount(rootEl, { onChange: function (s) {} })   // s = { mode, fee, feeKey, complete }
     rx.mode() / rx.setMode('frame'|'rx') / rx.fee() / rx.validate() -> error string | null (always validates; call it only in Rx mode)
     rx.lines(variantId, qty, props) -> { pair, items } (PDP interface); rx.items(variantId, qty) -> cart lines ([frame] or [frame + Rx fee] with the live line properties)
     rx.reset() / rx.fees / rx.el
   Mounting the same element twice returns the existing instance. */
(function () {
  'use strict';
  if (window.WNRx) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var q2 = function (n) { return (n > 0 ? '+' : '') + n.toFixed(2); };
  function fmt(cents) { var d = (cents / 100).toFixed(2); return '$' + (d.slice(-3) === '.00' ? d.slice(0, -3) : d); }

  function mount(root, opts) {
    if (!root) return null;
    if (root.__wnrx) return root.__wnrx;
    opts = opts || {};
    var feesEl = $('[data-wn-rx-fees]', root) || (root.closest('[data-wn-rx]') && $('[data-wn-rx-fees]', root.closest('[data-wn-rx]')));
    var fees = opts.fees || JSON.parse((feesEl || {}).textContent || 'null');
    var mode = root.getAttribute('data-mode') === 'rx' ? 'rx' : 'frame';
    var dual = $('[data-rx-dual]', root);
    var panel = $('[data-rx-panel]', root);

    function val(k) { var e = $('[data-rx="' + k + '"]', root); return e ? String(e.value).trim() : ''; }
    function feeKey() {
      var c = Math.min(parseFloat(val('od_cyl')) || 0, parseFloat(val('os_cyl')) || 0);
      return c <= -4.25 ? 'large' : c <= -2.25 ? 'medium' : 'small';
    }
    function fee() { return fees ? fees[feeKey()] : null; }
    function complete() {
      var eyes = !!(val('od_sph') && val('os_sph'));
      var pd = dual && dual.checked ? !!(val('pd_r') && val('pd_l')) : !!val('pd');
      var ok = !!($('[data-rx-confirm]', root) || {}).checked;
      return [eyes, pd, ok];
    }

    // build SPH / CYL option lists exactly like live
    $$('select[data-rx$="_sph"]', root).forEach(function (s) {
      s.innerHTML = '<option value="">Select</option>';
      for (var n = 24; n >= -32; n--) { var o = document.createElement('option'); o.textContent = n === 0 ? '0.00' : q2(n / 4); s.appendChild(o); }
    });
    $$('select[data-rx$="_cyl"]', root).forEach(function (s) {
      s.innerHTML = '<option value="">None</option>';
      for (var n = -1; n >= -24; n--) { var o = document.createElement('option'); o.textContent = (n / 4).toFixed(2); s.appendChild(o); }
    });

    function sync() {
      if (!fees) return;
      var key = feeKey(), f = fees[key];
      var tierEl = $('[data-rx-tier]', root); if (tierEl) tierEl.textContent = f.label;
      var priceEl = $('[data-rx-fee-price]', root); if (priceEl) priceEl.textContent = '+' + fmt(f.price);
      $$('[data-rx-t]', root).forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-rx-t') === key); });
      var th = $('[data-rx-thumb]', root); if (th) th.style.transform = 'translateX(' + ({ small: 0, medium: 1, large: 2 }[key] * 100) + '%)';
      $$('select[data-rx], input[data-rx]', root).forEach(function (x) { x.classList.toggle('is-filled', !!x.value); if (x.value) x.classList.remove('is-invalid'); });
      var done = complete(), cur = done.indexOf(false);
      $$('[data-rx-step]', root).forEach(function (s, i) { s.classList.toggle('is-done', done[i]); s.classList.toggle('is-on', i === cur || done[i]); });
      var p = $('[data-rx-progress]', root); if (p) p.style.width = Math.max(8, (done.filter(Boolean).length / 3) * 100) + '%';
      emit();
    }
    function emit() {
      if (typeof opts.onChange === 'function') {
        var c = complete();
        opts.onChange({ mode: mode, fee: fee(), feeKey: feeKey(), complete: c[0] && c[1] && c[2] });
      }
    }
    function setMode(m) {
      mode = m === 'rx' ? 'rx' : 'frame';
      root.setAttribute('data-mode', mode);
      $$('[data-rx-mode]', root).forEach(function (x) { x.setAttribute('aria-selected', String(x.getAttribute('data-rx-mode') === mode)); });
      if (panel) panel.hidden = mode !== 'rx';
      root.classList.toggle('is-rx', mode === 'rx');
      emit();
    }
    function validate() {
      var need = ['od_sph', 'os_sph'].concat(dual && dual.checked ? ['pd_r', 'pd_l'] : ['pd']);
      var bad = null;
      need.forEach(function (k) { var el = $('[data-rx="' + k + '"]', root); if (el && !el.value) { el.classList.add('is-invalid'); bad = bad || el; } });
      if (bad) { bad.focus(); return 'Please add SPH for both eyes and your PD.'; }
      var eyes = ['od', 'os'];
      for (var i = 0; i < 2; i++) {
        var e = eyes[i], c = val(e + '_cyl'), a = val(e + '_axis');
        if ((c && !a) || (!c && a)) { var el = $('[data-rx="' + e + '_axis"]', root); el.classList.add('is-invalid'); el.focus(); return (e === 'od' ? 'Right' : 'Left') + ' eye: CYL and AXIS go together.'; }
        if (a && (+a < 0 || +a > 180)) { var el2 = $('[data-rx="' + e + '_axis"]', root); el2.classList.add('is-invalid'); el2.focus(); return 'AXIS must be between 0 and 180.'; }
      }
      if (!$('[data-rx-confirm]', root).checked) return 'Please confirm your prescription is valid.';
      return null;
    }
    function items(variantId, qty, props) {
      qty = qty || 1;
      if (mode !== 'rx' || !fees) return [{ id: +variantId, quantity: qty }];
      return lines(variantId, qty, props).items;
    }
    /* PDP-compatible: always returns the Rx pair { pair, items:[frame line, fee line] } */
    function lines(variantId, qty, props) {
      qty = qty || 1;
      var f = fee(), isDual = dual && dual.checked;
      var pd = isDual ? 'R ' + val('pd_r') + ' / L ' + val('pd_l') : val('pd');
      var line = function (k) { return 'SPH ' + val(k + '_sph') + ' · CYL ' + (val(k + '_cyl') || 'None') + ' · AXIS ' + (val(k + '_axis') || '-'); };
      var pair = 'rxpair-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var p = {}; if (props) for (var k in props) p[k] = props[k];
      p.Prescription = 'RX Size: ' + f.label + '\nRight Eye (OD): ' + line('od') + '\nLeft Eye (OS): ' + line('os') + '\nPD: ' + pd;
      p['_Whisply RX Pair'] = pair;
      return { pair: pair, items: [
        { id: +variantId, quantity: qty, properties: p },
        { id: f.id, quantity: qty, properties: { '_Lab Cost': f.lab, '_Whisply RX Pair': pair, '_RX': 'OD:' + val('od_sph') + '/' + (val('od_cyl') || '0') + 'x' + (val('od_axis') || '000') + ' | OS:' + val('os_sph') + '/' + (val('os_cyl') || '0') + 'x' + (val('os_axis') || '000') + ' | PD:' + pd } }
      ] };
    }
    function reset() {
      $$('select[data-rx], input[data-rx]', root).forEach(function (x) { x.value = ''; x.classList.remove('is-invalid', 'is-filled'); });
      var cf = $('[data-rx-confirm]', root); if (cf) cf.checked = false;
      if (dual) dual.checked = false;
      var pd2 = $('[data-rx-pd2]', root); if (pd2) pd2.hidden = true;
      var pd1 = $('[data-rx="pd"]', root); if (pd1) { pd1.closest('label').style.opacity = '1'; pd1.closest('label').hidden = false; }
      sync();
    }

    $$('[data-rx-mode]', root).forEach(function (t) { t.addEventListener('click', function () { setMode(t.getAttribute('data-rx-mode')); }); });
    if (dual) dual.addEventListener('change', function () {
      var pd2 = $('[data-rx-pd2]', root); if (pd2) pd2.hidden = !dual.checked;
      var pd1 = $('[data-rx="pd"]', root); if (pd1) { pd1.closest('label').hidden = dual.checked; if (dual.checked) { pd1.value = ''; pd1.classList.remove('is-invalid'); } }
      sync();
    });
    root.addEventListener('change', sync);
    root.addEventListener('input', sync);

    var api = { el: root, fees: fees, mode: function () { return mode; }, setMode: setMode, fee: fee, feeKey: feeKey, validate: validate, items: items, lines: lines, reset: reset, sync: sync, fmt: fmt };
    root.__wnrx = api;
    setMode(mode);
    sync();
    return api;
  }

  window.WNRx = { mount: mount, fmt: fmt };
})();
